<template>
  <b-modal ref="modal" title="Nuovo documento" centered body-class="p-0" no-close-on-backdrop>

    <div role="group" class="col-12 stack-label">
      <label>Seleziona anno di imposta</label>
       <b-form-select v-model="anno" :options="annoImpostaOptions" size="sm"/>
    </div>

    <div role="group" class="col-12 stack-label">
      <label>Seleziona unità immobiliare</label>
       <b-form-select v-model="codiceUib" :options="codiceUibOptions" size="sm"/>
    </div>

    <template slot="modal-footer">
      <b-button variant="success" :disabled="!canSubmit" @click="addNew">
        <font-awesome-icon icon="plus"/> Aggiungi
      </b-button>

      <b-button variant="outline-secondary" @click="close">
        <font-awesome-icon icon="times"/> Chiudi
      </b-button>
    </template>

  </b-modal>
</template>

<script>
export default {
  name: 'NuovaDichiarazioneModal',
  data () {
    return {
      anno: '',
      codiceUib: ''
    }
  },

  computed: {
    annoImpostaOptions () {
      return this.$store.state.options.annoImposta
    },
    codiceUibOptions () {
      return this.$store.state.options.unitaImmobiliare
    },
    canSubmit () {
      return this.anno && this.codiceUib
    }
  },

  methods: {

    async open () {
      this.anno = ''
      this.codiceUib = ''
      await Promise.all([
        this.$store.dispatch('options/loadAnnoImpostaOptions'),
        this.$store.dispatch('options/loadUnitaImmobiliareOptions')
      ])
      this.$refs.modal.show()
    },

    close () {
      this.$refs.modal.hide()
    },

    async addNew () {
      try {
        let rs = await this.$store.dispatch('dichiarazioni/addNew', { annoImposta: this.anno, codiceUib: this.codiceUib })
        this.close()
        this.$router.push({ name: 'dichiarazione', params: { id: rs.id } })
      } catch (err) {
        // L'errore potrebbe dipendere dalla presenza di una bozza per lo stesso anno dichiarazione.
        // console.log('NEW Errore err', JSON.stringify(err))
        // console.log('NEW Errore response', JSON.stringify(err.response))
        // console.log('NEW Errore message', err.response.data.message)
        // console.log('NEW Errore numero', err.response.data.numero, err.response.data.numero === 20007)

        if (err.response.data.numero === 20007) {
          // Bozza già presente per l'anno di imposta selezionato.
          this.$ui.showError(err)
          this.$refs.modal.hide()
          // this.$router.push({ name: 'dichiarazioni' })
        } else {
          this.$ui.showError(err)

          // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
          this.$router.push({ name: 'home' })
        }
      }
    }
  }
}
</script>
